import { server } from '../constants';
import { httpClient } from '../utils/HttpClient';

/*______________
 *  File Data
 *==============
 */

/**
 * save()
 *
 * Method: POST
 * Detail: insert issue file (image)
 * API Doc: /muit-iDev/pdpa-im-api/-/wikis/Transaction/IssueFile
 */
export function save(data) {
  return httpClient
    .post(`${server.FILE_URL}/save`, data)
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}

/**
 * thumbnail()
 * @param {object} props
 * @param {string} props.issue_id
 * @param {string} props.file_id
 * Method: get
 * Detail: get thumbnail file (image)
 * API Doc: /muit-iDev/pdpa-im-api/-/wikis/Transaction/IssueFile#get-thumbnail-file
 */
export function thumbnail({ issue_id, file_id }) {
  return httpClient
    .get(`${server.FILE_URL}/thumbnail/${issue_id}/${file_id}`)
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}

/**
 * thumbnails()
 * @param {object} props
 * @param {string} props.issue_id
 * @param {array} props.files array of file_id
 * Method: get
 * Detail: get thumbnail file (image)
 * NOTE: extend from thumbnail()
 */
export async function thumbnails({ issue_id, files = [] }) {
  let contents = [];
  if (files.length) {
    for (let file_id of files) {
      const content = await thumbnail({ issue_id, file_id }).then(
        (data) => data
      );
      contents.push(content);
    }
  }
  return contents;
}

/**
 * thumbnail()
 * @param {object} props
 * @param {string} props.issue_id
 * @param {string} props.file_id
 * Method: get
 * Detail: get origin(al) file (image)
 * API Doc: /muit-iDev//pdpa-im-api/-/wikis/Transaction/IssueFile#get-origin-file
 */
export async function original({ issue_id, file_id }) {
  return httpClient
    .get(`${server.FILE_URL}/origin/${issue_id}/${file_id}`)
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}
